module.exports = __webpack_public_path__ + "static/betterer-women-point-up-9717796085e0447aa2d6e1a66588b9aa.png";